module.exports = __webpack_public_path__ + "img/comment-smile.f22c4e11.svg";